import instamapsBreadcrumbs from '../shared/components/breadcrumbs/breadcrumbs.vue';
import instamapsMessageModal from '../shared/components/message-modal/message-modal.vue';
import messages from './login-translations';
import { LoginService } from './services/loginService';
import { ApplicationConstants } from '../shared/applicationConstants';

export default {
    name: 'instamapsLogin',
    data: () => {
        return {
            user: "",
            password: "",
            socialAuth: ApplicationConstants.socialAuth,
            modalIsError: false,
            modalIsLoaded: false,
            modalTitle: "",
            modalMessage: "",
            eacat: ApplicationConstants.eacatUrl,
            token: "",
        };
    },
    i18n: {
        messages,
    },
    components: {
        instamapsBreadcrumbs,
        instamapsMessageModal,
    },
    props: {
        hasBreadcrumbs: { type: Boolean },
    },
    methods: {
        login: function() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    LoginService.httpPostLogin(this.user, this.password).then((response) => {
                        if (response.status==="OK") {
                            if (response.mapBusinessId){
                                this.$emit('login', {mapBusinessId: response.mapBusinessId});
                            }
                            else {
                                this.$emit('login');
                            }
                        }else{
                            this.showModalError();
                        }
                    }).catch(() => {
                        this.showModalError();
                    });
                }
            });
        },
        loginToken: function(){
            LoginService.httpPostLoginToken(this.token).then((response) => {
                if (response.status==="OK") {
                    if (response.mapBusinessId){
                        this.$emit('login', {mapBusinessId: response.mapBusinessId});
                    }
                    else {
                        this.$emit('login');
                    }
                }else{
                    this.showModalError();
                }
            }).catch(() => {
                this.showModalError();
            });
        },
        loaded: function(){
            this.modalIsError = false;
            this.modalIsLoaded = false;
        },
        showModalError: function(){
            this.modalTitle = this.$t('titleErrorLogin');
            this.modalMessage = this.$t('messageErrorLogin');
            this.modalIsError = true;
            this.modalIsLoaded = true;
        },
    },
    mounted(){
        if(this.$route.query.token){
            this.token = this.$route.query.token;
            this.loginToken();
        }
    },
};



// WEBPACK FOOTER //
// ./src/login/login.js